import React from 'react';
import enUS from '../tokens/en-US.json';
import esES from '../tokens/es-ES.json';
import jpJP from '../tokens/jp-JP.json';
import ptBR from '../tokens/pt-BR.json';
import { Text } from './Text';
import {Button} from './Text';

export const translations = {
  'en-US': enUS,
  'es-ES': esES,
  'jp-JP': jpJP,
  'pt-BR': ptBR,
};

const Card = ({ buyMilesIcon, title, description, buttonText, buttonId, url, promoToken, buttonClassName, languageCode, token }) => {
  
  return (
    

    <div className="card">
      
      <div className="card-img-container">
        {buyMilesIcon && <img src={buyMilesIcon} alt={<Text languageCode={languageCode} token={title} />} className="card-image" />}
        {promoToken && (
          <div className="ribbon">
            <div className="sale-tag">
              <Text languageCode={languageCode} token={promoToken} />
            </div>
          </div>
        )}
      </div>

      <div className="card-text-container">
        <h3 className="card-title">
          <Text languageCode={languageCode} token={title} />
        </h3>
        <p className="card-description">
          <Text languageCode={languageCode} token={description} />
        </p>
        <Button
          id={buttonId}
          token={buttonText}
          languageCode={languageCode}
          url={url}
          className={`card-button ${buttonClassName}`}
        />
      </div>
    </div>
  );
};

export default Card;